import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import softwareImage from "../../assets/images/dashboardDesktop.png";
import './immersiveNew.css'

const SoftwarePlatform = () => {
  return (
    <div className="software-platform-section">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <div className="software-text">
              <h4>Powerful Software & Platform Solutions</h4>
              <p>Our <strong>InsightXR</strong> platform provides:</p>
              <ul>
                <li><strong>Advanced analytics</strong> to track engagement and learning outcomes.</li>
                <li><strong>An embedded LMS</strong> for seamless content management and loading.</li>
                <li><strong>Rapid content loading</strong> and improved system responsiveness.</li>
              </ul>
            </div>
          </Col>
          <Col md={6}>
            <div className="software-image">
              <img src={softwareImage} alt="Software Platform" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SoftwarePlatform;
